<template>
  <div class="page-wrapper authorization">
    <navbar back fixed bg>
      <span slot="title">授权绑定</span>
    </navbar>
    <div class="page-content" :class="{noTop: isWechat}">
      <form class="form" @submit.prevent="authorization">
        <div class="form-input-group">
          <div class="form-group">
            <label class="form-label">开户行</label>
            <input type="text" class="form-control repaymentBankBranch" name="repaymentBankBranch" readonly v-model="cardInfo.repaymentBankBranch" placeholder="请输入开户行">
          </div>
          <div class="form-group">
            <label class="form-label">账户名称</label>
            <input type="text" class="form-control repaymentCardAccountName" name="repaymentCardAccountName" readonly v-model="cardInfo.repaymentCardAccountName" placeholder="请输入账户名">
          </div>
          <div class="form-group">
            <label class="form-label">银行卡号</label>
            <input type="text" class="form-control repaymentCardNumber" name="repaymentCardNumber" readonly v-model="cardInfo.repaymentCardNumber" placeholder="请输入银行卡号">
          </div>
          <div class="form-group">
            <label class="form-label">预留手机号</label>
            <input type="text" class="form-control repaymentReserveTelNum" name="repaymentReserveTelNum" readonly v-model="cardInfo.repaymentReserveTelNum" placeholder="请输入预留手机号">
          </div>
          <div class="form-group">
            <label class="form-label">短信验证码</label>
            <input type="text" class="form-control checkCode" name="checkCode" v-model="checkCode" placeholder="请输入短信验证码">
            <a href="javascript:;" class="btn-sms" :class="{disabled: isSmsClick}" @click="sendSms">{{smsBtnText}}</a>
          </div>
        </div>
        <div class="form-group from-group-submit">
          <button type="submit" class="btn btn-submit">提交</button>
        </div>
      </form>
    </div>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
import Navbar from 'components/navbar/navbar'
import Toast from 'components/toast/toast'
import Spinner from 'components/spinner/spinner'

export default {
  components: {
    Navbar,
    Spinner,
    Toast
  },
  data () {
    return {
      isWechat: false,
      cardInfo: {},
      checkCode: '',
      smsBtnText: '获取验证码',
      isSmsClick: false,
      toastShow: false,
      toastText: '',
      loading: false
    }
  },
  created () {
    if (this.$device.isWechat) {
      this.isWechat = true
    }
  },
  mounted () {
    this.token = this.$cache.getUserToken()
    this.orderNo = this.$route.params.orderNo
    this.getRepaymentCard()
  },
  beforeDestroy () {
    this.timer && clearInterval(this.timer)
  },
  methods: {
    sendSms () {
      if (this.isSendSms) {
        return
      }
      this.isSmsClick = true
      this.$ajax({
        url: '/center/sendVerificationCode.jhtml',
        params: {
          no: this.orderNo,
          uid: this.token.uid
        },
        done: () => {
          let time = 60
          this.smsBtnText = `${time}s`
          time--
          this.timer = setInterval(() => {
            if (time < 0) {
              this.isSmsClick = false
              this.smsBtnText = '重新获取'
              return clearInterval(this.timer)
            }
            this.smsBtnText = `${time}s`
            time--
          }, 1000)
        },
        fail: (m) => {
          this.isSmsClick = false
          this.$dialog(m)
        }
      })
    },
    getRepaymentCard () {
      this.loading = true
      return this.$ajax({
        url: '/center/getRepaymentCard.jhtml',
        params: {
          no: this.orderNo,
          uid: this.token.uid
        },
        done: (data) => {
          this.cardInfo = data
        },
        always: () => {
          this.loading = false
        }
      })
    },
    validate () {
      // if (!this.cardInfo.repaymentBankBranch) {
      //   this.toastText = '开户行不能为空'
      //   return !(this.toastShow = true)
      // }

      // if (!this.cardInfo.repaymentCardAccountName) {
      //   this.toastText = '账户名不能为空'
      //   return !(this.toastShow = true)
      // } else if (!/^(([a-zA-Z+\\.?\\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\\·?\u4e00-\u9fa5+]{2,30}$))/.test(this.cardInfo.repaymentCardAccountName)) {
      //   this.toastText = '请输入中文或英文账户名'
      //   return !(this.toastShow = true)
      // }

      // if (!this.cardInfo.repaymentCardNumber) {
      //   this.toastText = '账号不能为空'
      //   return !(this.toastShow = true)
      // } else if (!/^([1-9]{1})(\d{14}|\d{18})$/.test(this.cardInfo.repaymentCardNumber)) {
      //   this.toastText = '账号不正确'
      //   return !(this.toastShow = true)
      // }

      // if (!this.cardInfo.repaymentReserveTelNum) {
      //   this.toastText = '手机号不能为空'
      //   return !(this.toastShow = true)
      // } else if (!/^1\d{10}$/.test(this.cardInfo.repaymentReserveTelNum)) {
      //   this.toastText = '手机格式不正确'
      //   return !(this.toastShow = true)
      // }

      if (!this.checkCode) {
        this.toastText = '短信验证码不能为空'
        return !(this.toastShow = true)
      } else if (!/^\d{6}$/.test(this.checkCode)) {
        this.toastText = '短信验证码格式错误'
        return !(this.toastShow = true)
      }
      return true
    },
    authorization () {
      if (this.validate()) {
        this.loading = true
        this.$ajax({
          url: '/center/doBankCardAuthorization.jhtml',
          params: {
            uid: this.token.uid,
            no: this.orderNo,
            checkCode: this.checkCode
          },
          done: (info) => {
            this.$dialog({
              content: '已提交',
              onConfirm: () => {
                this.$router.go(-1)
              }
            })
          },
          always: () => {
            this.loading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../common/css/mixmin'
.authorization {
  .form-input-group{
    background-color: #fff;
    box-shadow: 0 px2rem(10) px2rem(15) rgba(171,185,197, 1);
  }
  .form-group {
    position: relative;
    display: flex;
    padding: 0 px2rem(30px);
    height: px2rem(108px);
    line-height: px2rem(108px);
    border-top: 1px solid #F3F3F3;
    align-items: center;
    &.from-group-submit {
      padding-top: px2rem(120px);
      height: px2rem(210px);
      .btn {
        display: block;
        height: px2rem(80px);
        line-height: px2rem(80px);
        font-size: px2rem(32px);
        border: none;
        text-align: center;
        border-radius px2rem(8px);
        letter-spacing px2rem(4);
        width: 85%;
        color: #fff;
        margin: 0 auto 20px;
        background-color: #60c9c8;
        box-shadow: 0 0 px2rem(4px) rgba(18,119,163, .75);
      }
    }
    .form-label {
      width: px2rem(180px);
      height: 100%;
      font-size: 14px;
      color: #275482;
    }
    .form-control {
      flex: 1;
      height: 100%;
      color: #129FDD;
      border: 0;
      font-size 11px
      font-weight: bold;
      &::placeholder {
        color: #999;
        font-weight: normal;
      }
    }
    .btn-sms {
      width: px2rem(150px);
      height: px2rem(36px);
      background-color: #60c9c8;
      border-radius: px2rem(36px);
      color: #fff;
      line-height: px2rem(36px);
      text-align: center;
      &.disabled {
        background-color: #7F868C
      }
    }
  }
}

.noTop{
  top: 0 !important;
}

</style>



// WEBPACK FOOTER //
// authorization.vue?072b3ce4